import { globalToken } from 'src/styles/theme'

// Maximum width for small header layout, used for responsive design
export const SMALL_LAYOUT_MAX_WIDTH = `${globalToken.screenLG}px`
